export default __webpack_public_path__ + "static/legacy-14a0589d512a9c75279960ec5cd37822.jpg";